import { TenantSettingAffiliateBilling } from "types/enums";
import * as z from "zod";

export const schema = z
    .object({
        title: z.string().min(1, "forms.general-validation.field_cannot_be_empty"),
        slug_name: z.string().min(1, "forms.general-validation.field_cannot_be_empty"),
        domain: z.string(),
        logo: z.string().nullable().optional(),
        favicon: z.string().nullable().optional(),
        template: z.string(),
        country_id: z.number(),
        language_id: z.number(),
        currency_id: z.number(),
        minimum_payment: z.number(),
        new_partner_approval: z.string(),
        new_advertiser_approval: z.string(),
        tags: z.array(z.string()),
        terms_and_conditions: z.string(),
        test: z.string(),
        affiliate_billing: z.nativeEnum(TenantSettingAffiliateBilling),
        show_affiliate_program: z.boolean(),
        affiliate_categories: z.string().array(),
        webhook_custom_parameters: z.boolean(),
        webhook_eid: z.string(),
        webhook_advertiser_id: z.string(),
        webhook_advertiser_custom_id: z.string(),
    })
    .superRefine((val, ctx) => {
        if (val.show_affiliate_program && val.affiliate_categories.length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["affiliate_categories"],
                message: "forms.tenant-settings.fields.affiliate_categories.required_when_shown_in_catalog",
            });
        }
    });

export type TenantSettingsFormData = z.infer<typeof schema>;
